module.exports = __webpack_public_path__ + "static/media/08_Maf_NuestroEquipo_EmmanuelMartinez.c-01.fa80faef.png";